<template>
    <a-card class="OrderManage">
        <a-form-model layout="inline">
            <a-form-model-item label="输入搜索">
                <a-input placeholder="请输入手机号或订单编号" allow-clear :maxLength="20" v-model="searchForm.query" style="width:220px;"/>
            </a-form-model-item>
            <a-form-model-item label="购买时间">
                <a-range-picker 
                    v-model="date"
                    show-time
                    format="YYYY-MM-DD HH:mm"
                    :disabled-date="current => current && current > (new Date().getTime())"/>
            </a-form-model-item>
            <a-form-model-item label="状态">
                <a-select class="serach-item" allowClear v-model="searchForm.status" @keyup.enter="getList(1)" placeholder="请选择">
                    <a-select-option :value="index" v-for="(item,index) in statusArr" :key="index">{{item}}</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item style="margin-left: 35px;">
                <a-button type="primary" @click="getList(1)">查询</a-button>
                <a-button style="margin: 0 35px 0 15px;" @click="resetSearch()">重置</a-button>
            </a-form-model-item>
            <a-form-model-item style="position: absolute;right: 0;">
                <a-button @click="refreshOrder()" :disabled="disReload > 0">
                    <a-icon type="reload" />
                    <span v-if="disReload > 0">{{reloadText}}</span>
                </a-button>
            </a-form-model-item>
        </a-form-model>
        <div class="table">
            <a-table style="min-width: 800px;"
                :columns="columns"
                row-key="id"
                :pagination="tableRelevant.tablePagination"
                :loading="tableRelevant.tableLoading"
                :locale="tableRelevant.locale"
                :dataSource="tableRelevant.tableDataSource">
                <div slot="phone" slot-scope="text, record" class="_flex">
                    <span :class="text.neworderMark.includes(1) ? 'errorClass' : ''" style="width:83px">{{text.phone}}</span>
                    <a-popconfirm placement="bottom" ok-text="确定" cancel-text="取消" @confirm="updateMobile(text)" @cancel="cancelMobile()">
                        <a-icon slot="icon" type="edit" style="display:none;"  />
                        <template slot="title">
                            <a-form-model
                                ref="ruleForm"
                                :model="form.data"
                                :rules="form.rules"
                                :label-col="{span:6}"
                                :wrapper-col="{span:24}">
                                <a-form-model-item label="" prop="mobile">
                                    <a-input v-model="form.data.mobile" placeholder="请输入手机号" style="width:100%;"/>
                                </a-form-model-item>
                            </a-form-model>
                        </template>
                        <a-icon type="edit" class="editIcon" style="margin-left:10px;"/>
                    </a-popconfirm>
                </div>
                <div slot="goodsNum" slot-scope="text, record" class="_flex">
                    <span style="min-width:25px;">{{text.skuCount}}</span>
                    <div v-if="text.neworderMark.includes(2)">
                        <a-icon slot="icon" type="edit" style="display:none;"  />
                        <div class="source">重复</div>
                    </div>
                    <div v-if="text.neworderMark.includes(4)">
                        <a-icon slot="icon" type="edit" style="display:none;"  />
                        <div class="source">异常</div>
                    </div>
                </div>
                <div slot="price" slot-scope="text, record">
                    ￥{{text.price}}
                </div>
                <div slot="time" slot-scope="text, record">
                    {{text.orderCreateTime}}
                </div>
                <div slot="status" slot-scope="text, record" class="_flex">
                    <span>{{ statusArr[text.orderStatus]}}</span>
                </div>
                <div slot="action" slot-scope="text, record">
                    <a @click="view(text)" v-permission="`/operate/OrderManage/OrderDetail`">查看</a>
                </div>
            </a-table>
        </div>
    </a-card>
</template>

<script>
import $Bus from "@/pages/projectImpl/js/eventBus"
import {tableRelevant} from "@/pages/projectImpl/js/utils";

const columns = [
    { title: '订单编号', key: "1", dataIndex: 'outOrderId',},
    { title: '下单手机号', key: "2", scopedSlots: {customRender: 'phone'}},
    { title: '商品数量', key: "3", scopedSlots: {customRender: 'goodsNum'}},
    { title: '购买时间', key: "5", dataIndex: 'orderCreateTime',},
    { title: '订单金额', key: "4", scopedSlots: {customRender: 'price'}},
    { title: '状态', key: "6", scopedSlots: {customRender: 'status'}},
    { title: '操作', key: "7", scopedSlots: {customRender: 'action'}}
]
export default {
    name:'OrderManage',
    data () {
        const checkMobile = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入手机号'))
            } else {
                if (!/^1[3456789]\d{9}$/.test(value)) {
                    callback(new Error('请输入正确的手机号'))
                } else {
                    callback()
                }
            }
        }
        return {
            date:undefined,
            searchForm:{
                query:undefined,
                status:undefined,
            },
            columns,
            tableRelevant: tableRelevant.call(this,this.getList),
            statusArr: ['',"待发货", "已发货", "已完成", "已取消"],
            form:{
                data:{
                    mobile:null,
                },
                rules:{
                    mobile: [{ required: true, validator: checkMobile, trigger: "change" }],
                }
            },
            disReload:false,
            reloadText:''
        }
    },
    created () {

    },
    mounted() {
        $Bus.$emit("pageHeaderTitle", "订单列表");
        this.getList()
    },
    methods: {
        number(n){
            switch(n){
                case 7:
                    return [1,2,4] ;
                case 6:    
                    return [2,4] ;
                case 5:    
                    return [1,4] ;
                case 3:    
                    return [1,2] ;
                default:    
                    return [n] ;
            }
        },
        getList(pageIndex){
            if(this.date && this.date.length > 0){
                this.searchForm.startOrderTime = this.date[0].format("YYYY-MM-DD HH:mm")
                this.searchForm.endOrderTime = this.date[1].format("YYYY-MM-DD HH:mm")
            }else{
                this.searchForm.startOrderTime = undefined
                this.searchForm.endOrderTime = undefined
            }
            let params = {
                ...this.searchForm,
                pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                pageSize: this.tableRelevant.tablePagination.pageSize,
            }
            this.tableRelevant.tableLoading = true
            this.$http.operate.GetOrderPageList(params)
            .then(res => {
                this.tableRelevant.tableLoading = false
                    res.data.data.items.forEach(v=>{
                        v.neworderMark = this.number(v.orderMark)
                    })
                    this.tableRelevant.tableDataSource = res.data.data.items
                    this.tableRelevant.tablePagination.total = res.data.data.totalCount;
                    this.tableRelevant.tablePagination.current = res.data.data.pageIndex;
              
            })
            .catch(err=>{
                this.tableRelevant.tableLoading = false
            })
        },
        resetSearch(){
            this.date = undefined
            this.searchForm = {
                name:undefined,
                status:undefined,
            }
            this.getList(1)
        },
        view(text){
            // this.$router.push('/operate/OrderDetail')
            this.$router.push({
                path:'/operate/OrderManage/OrderDetail',
                query:{
                    outOrderId:text.outOrderId,
                    orderId:text.id,
                    mobile:text.phone,
                    // orderStatus:text.orderStatus
                }
            })
        },
        // 修改手机号
        updateMobile(text){
            if(!/^1[3456789]\d{9}$/.test(this.form.data.mobile)){
                this.form.data.mobile = ''
                this.$message.error('请输入正确手机号');
                return
            }
            let that = this
            let formData = new FormData();
            formData.append('OrderId',text.id)
            formData.append('Mobile',this.form.data.mobile)
            this.$http.operate.UpdateOrderPhone(formData)
            .then(res => {
                    this.$message.success('操作成功');
                    this.form.data.mobile = ''
                    this.getList(1)
               
            })
        },
        cancelMobile(){
            this.form.data.mobile = ''
            this.$refs.ruleForm.resetFields();
        },
        
        refreshOrder(){
            this.$http.operate.RefreshOrder()
            .then(res => {
                this.$message.destroy();
                    this.$message.success(res.data.message)
                    this.disReload = true
                    let time = 30;
                    let interval = setInterval(() => {
                    this.reloadText = `${--time}秒后重试`;
                        if (!time) {
                            this.disReload = false;
                            clearInterval(interval);
                            this.reloadText = "";
                        }
                    }, 1000)
                    setTimeout(()=>{
                        this.getList()
                    },1000)
            })
            .catch(err=>{
                this.$message.destroy();
                this.$message.error(res.data.message)
            })
        },
    }
}
</script>

<style scoped lang="less">
._flex{
    display:flex;
    align-items:center;
}
.source{
    margin-left:10px;
    padding:0 10px;
    font-size:12px;
    border-radius: 5px;
    border:1px solid #E4413E;
    color:#E4413E;
    background:#FDF2F5;
    cursor: pointer;
}
.editIcon{
    margin-left:10px;
    margin-top:3px;
    color:rgba(0,0,0,.65);
    cursor: pointer;
}
.errorClass{
    color:#f00;
}
/deep/ .ant-form-item{
    margin-bottom:0;
}
</style>
